const subscriptionRoutes = [
  {
    path: '/subscriptions',
    component: () => import('@/layouts/main/archistar/Main.vue'),
    children: [
      {
        path: 'all',
        name: 'all-subscriptions',
        component: () => import('@/views/pages/archistar/acv.vue'),
        props: {
          scope: 'reports.allSubscriptions'
        },

        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Reports'
            },
            {
              title: 'All Subscriptions',
              active: true
            }
          ],
          pageTitle: 'All Subscriptions',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            },
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'snapshot/quarterly',
        name: 'subscriptions.snapshot.quarterly',
        component: () => import('@/components/archistar/table/SubscriptionSnapshotTable.vue'),
        props: {
          scope: 'reports.subscriptionSnapshotQuarterly'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Subscription'
            },
            {
              title: 'Snapshot',
              active: true
            }
          ],
          pageTitle: 'Snapshot Quarterly',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'snapshot/monthly',
        name: 'subscriptions.snapshot.monthly',
        component: () => import('@/components/archistar/table/SubscriptionSnapshotTable.vue'),
        props: {
          scope: 'reports.subscriptionSnapshotMonthly'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Subscription'
            },
            {
              title: 'Snapshot',
              active: true
            }
          ],
          pageTitle: 'Snapshot Monthly',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'snapshot/detailed',
        name: 'subscriptions.snapshot.detailed',
        component: () => import('@/components/archistar/table/SubscriptionSnapshotDetailedTable.vue'),
        props: {
          scope: 'reports.subscriptionSnapshotDetailed'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Subscription'
            },
            {
              title: 'Snapshot',
              active: true
            }
          ],
          pageTitle: 'Snapshot Detailed',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'active',
        name: 'active-subscriptions',
        component: () => import('@/components/archistar/table/SubscriptionTable.vue'),
        props: {
          scope: 'reports.activeSubscriptions'
        },

        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Reports'
            },
            {
              title: 'Active Subscriptions',
              active: true
            }
          ],
          pageTitle: 'Active Subscriptions',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            },
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'invoices',
        name: 'invoices',
        component: () => import('@/components/archistar/table/InvoiceTable.vue'),
        props: {
          scope: 'reports.invoices'
        },

        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Reports'
            },
            {
              title: 'Invoices',
              active: true
            }
          ],
          pageTitle: 'Invoices',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'new-sales',
        name: 'subscription.newSales',
        component: () => import('@/components/archistar/table/SubscriptionTable.vue'),
        props: {
          scope: 'reports.newSales'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Reports'
            },
            {
              title: 'New Sales',
              active: true
            }
          ],
          pageTitle: 'New Sales Report',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'upcoming-rollovers',
        name: 'subscription.upcomingRollovers',
        component: () => import('@/components/archistar/table/SubscriptionTable.vue'),
        props: {
          scope: 'reports.upcomingRollovers'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Reports'
            },
            {
              title: 'Upcoming Rollovers',
              active: true
            }
          ],
          pageTitle: 'Upcoming Rollovers Report',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'recentrenewals',
        name: 'reports-recentrenewals',
        component: () => import('@/components/archistar/table/SubscriptionTable.vue'),
        props: {
          scope: 'reports.recentRenewals'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Reports'
            },
            {
              title: 'Recently Renewed',
              active: true
            }
          ],
          pageTitle: 'Recently Renewed Report',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'paused',
        name: 'reports-pausedSubscriptions',
        component: () => import('@/components/archistar/table/SubscriptionTable.vue'),
        props: {
          scope: 'reports.pausedSubscriptions'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Reports'
            },
            {
              title: 'Recently Paused',
              active: true
            }
          ],
          pageTitle: 'Recently Paused Report',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'expires-soon',
        name: 'subscription.expiresSoon',
        component: () => import('@/components/archistar/table/SubscriptionTable.vue'),
        props: {
          scope: 'reports.expiresSoon'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Reports'
            },
            {
              title: 'Contract Expires Soon',
              active: true
            }
          ],
          pageTitle: 'Contract Expires Soon Report',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'active',
        name: 'subscription.active',
        component: () => import('@/components/archistar/table/SubscriptionTable.vue'),
        props: {
          scope: 'reports.activeSubscriptions'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Subscriptions'
            },
            {
              title: 'Active Subscriptions',
              active: true
            }
          ],
          pageTitle: 'Active Subscriptions',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'recent-cancellations',
        name: 'subscription.recentCancellations',
        component: () => import('@/components/archistar/table/SubscriptionTable.vue'),
        props: {
          scope: 'reports.recentCancellations'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Reports'
            },
            {
              title: 'Recent Cancellations',
              active: true
            }
          ],
          pageTitle: 'Recent Cancellations Report',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'pause-request',
        name: 'subscription.pause-request',
        component: () => import('@/components/archistar/table/SubscriptionTable.vue'),
        props: {
          scope: 'reports.pauseRequest'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Subscription'
            },
            {
              title: 'Pause Request',
              active: true
            }
          ],
          pageTitle: 'Pause Request',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'cancellation-request',
        name: 'subscription.cancellation-request',
        component: () => import('@/components/archistar/table/SubscriptionTable.vue'),
        props: {
          scope: 'reports.cancellationRequest'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Subscription'
            },
            {
              title: 'Cancellation Request',
              active: true
            }
          ],
          pageTitle: 'Cancellation Request',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },

      {
        path: 'change-request',
        name: 'subscription.change-request',
        component: () => import('@/components/archistar/table/SubscriptionTable.vue'),
        props: {
          scope: 'reports.changeRequest'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Subscription'
            },
            {
              title: 'Change Request',
              active: true
            }
          ],
          pageTitle: 'Change Request',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },

      {
        path: 'chargebee-user-subscription-report',
        name: 'chargebee-user-subscription-report',
        component: () => import('@/components/archistar/table/table_withDate.vue'),
        props: {
          scope: 'subscriptions.chargebeeSubscriptions'
        },

        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Subscription'
            }
          ],
          pageTitle: 'Chargebee User Subscription Report',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'chargebee-user-subscription-report-paid-only',
        name: 'chargebee-user-subscription-report-paid-only',
        component: () => import('@/components/archistar/table/table_withDate.vue'),
        props: {
          scope: 'subscriptions.chargebeeSubscriptionsPaidOnly'
        },

        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Subscription'
            }
          ],
          pageTitle: 'Chargebee User Subscription Report (Paid Only)',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      }
    ]
  }
];

export default subscriptionRoutes;
